import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import img1 from "../images/Picture2.png";
import img2 from "../images/Picture3.png";
import img3 from "../images/Picture4.png";
import img4 from "../images/Picture5.png";

const Certification = () => {
  const images = [
    { id: 1, src: img1, alt: "Certification 1" },
    { id: 2, src: img2, alt: "Certification 2" },
    { id: 3, src: img3, alt: "Certification 3" },
    { id: 4, src: img4, alt: "Certification 4" },
  ];

  const [currentIndex, setCurrentIndex] = useState(null);

  const openPopup = (index) => setCurrentIndex(index);
  const closePopup = () => setCurrentIndex(null);

  const nextImage = () => setCurrentIndex((prev) => (prev + 1) % images.length);

  const prevImage = () =>
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));

  return (
    <section className="certification">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="text-white">Certification</h2>
          </div>

          <div className="col-12">
            <Slider
              infinite
              speed={800}
              slidesToShow={3}
              slidesToScroll={1}
              autoplay
              autoplaySpeed={3000}
              pauseOnHover
              arrows
              swipe
              responsive={[
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                  },
                },
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                  },
                },
              ]}
            >
              {images.map((image, index) => (
                <div key={image.id} onClick={() => openPopup(index)}>
                  <div className="certification_card">
                    <img src={image.src} alt={image.alt} />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>

      {/* Modal */}

      {currentIndex !== null && (
        <div className="modal_overlay" onClick={closePopup}>
          <div className="modal_box" onClick={(e) => e.stopPropagation()}>
            <button className="modal_close" onClick={closePopup}>
              ×
            </button>

            <img
              src={images[currentIndex].src}
              alt={images[currentIndex].alt}
              className="modal_image"
            />

            <div className="modal_buttons">
              <button onClick={prevImage}>Previous</button>
              <button onClick={nextImage}>Next</button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Certification;
